/* tslint:disable */
/* eslint-disable */
/**
 * Credify API doc version 1
 * API documentations version 1.
 *
 * The version of the OpenAPI document: 1.0.0-oas3
 * Contact: dev@credify.one
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
/**
 * VNPTApi - axios parameter creator
 * @export
 */
export const VNPTApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This is a proxy base URL of VNPT eKYC API.  It requires an organization\'s access token that contains `idpass_provider:ekyc`.  - https://ekyc.vnpt.vn/admin-dashboard/en/documents/api#6-api-extracting-paper-information- - https://ekyc.vnpt.vn/admin-dashboard/en/documents/api#7-api-comparing-the-face-on-paper-with-the-portrait-face - https://ekyc.vnpt.vn/admin-dashboard/en/documents/api#8-check-the-real-face 
         * @summary VNPT Proxy
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        v1VnptPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/vnpt`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VNPTApi - functional programming interface
 * @export
 */
export const VNPTApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VNPTApiAxiosParamCreator(configuration)
    return {
        /**
         * This is a proxy base URL of VNPT eKYC API.  It requires an organization\'s access token that contains `idpass_provider:ekyc`.  - https://ekyc.vnpt.vn/admin-dashboard/en/documents/api#6-api-extracting-paper-information- - https://ekyc.vnpt.vn/admin-dashboard/en/documents/api#7-api-comparing-the-face-on-paper-with-the-portrait-face - https://ekyc.vnpt.vn/admin-dashboard/en/documents/api#8-check-the-real-face 
         * @summary VNPT Proxy
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async v1VnptPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1VnptPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VNPTApi - factory interface
 * @export
 */
export const VNPTApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VNPTApiFp(configuration)
    return {
        /**
         * This is a proxy base URL of VNPT eKYC API.  It requires an organization\'s access token that contains `idpass_provider:ekyc`.  - https://ekyc.vnpt.vn/admin-dashboard/en/documents/api#6-api-extracting-paper-information- - https://ekyc.vnpt.vn/admin-dashboard/en/documents/api#7-api-comparing-the-face-on-paper-with-the-portrait-face - https://ekyc.vnpt.vn/admin-dashboard/en/documents/api#8-check-the-real-face 
         * @summary VNPT Proxy
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        v1VnptPost(options?: any): AxiosPromise<void> {
            return localVarFp.v1VnptPost(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VNPTApi - interface
 * @export
 * @interface VNPTApi
 */
export interface VNPTApiInterface {
    /**
     * This is a proxy base URL of VNPT eKYC API.  It requires an organization\'s access token that contains `idpass_provider:ekyc`.  - https://ekyc.vnpt.vn/admin-dashboard/en/documents/api#6-api-extracting-paper-information- - https://ekyc.vnpt.vn/admin-dashboard/en/documents/api#7-api-comparing-the-face-on-paper-with-the-portrait-face - https://ekyc.vnpt.vn/admin-dashboard/en/documents/api#8-check-the-real-face 
     * @summary VNPT Proxy
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof VNPTApiInterface
     */
    v1VnptPost(options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * VNPTApi - object-oriented interface
 * @export
 * @class VNPTApi
 * @extends {BaseAPI}
 */
export class VNPTApi extends BaseAPI implements VNPTApiInterface {
    /**
     * This is a proxy base URL of VNPT eKYC API.  It requires an organization\'s access token that contains `idpass_provider:ekyc`.  - https://ekyc.vnpt.vn/admin-dashboard/en/documents/api#6-api-extracting-paper-information- - https://ekyc.vnpt.vn/admin-dashboard/en/documents/api#7-api-comparing-the-face-on-paper-with-the-portrait-face - https://ekyc.vnpt.vn/admin-dashboard/en/documents/api#8-check-the-real-face 
     * @summary VNPT Proxy
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof VNPTApi
     */
    public v1VnptPost(options?: AxiosRequestConfig) {
        return VNPTApiFp(this.configuration).v1VnptPost(options).then((request) => request(this.axios, this.basePath));
    }
}
